export const comments_5256814 = {"data":{"data":[],"links":{}}}